import React from "react";
import { KgCatalogEntityTile } from "../KgCatalogEntityTile";
import { KgCatalogSectionHeader } from "../KgCatalogSectionHeader";
import {
  CardGrid,
  CollapsibleBody,
  CollapsibleInner,
  EmptyNote,
  SectionCard,
} from "./KgCatalogSection.styles";
import type { KgCatalogSectionProps } from "./KgCatalogSection.types";

export const KgCatalogSection: React.FC<KgCatalogSectionProps> = ({
  section,
  icon,
  nodes,
  isOpen,
  onToggle,
  onSectionExternalLink,
  emptyMessage,
  expandedTableIds,
  onTableTileToggle,
  onNodeClick,
  selectedNodeId,
  className,
}) => (
  <SectionCard
    className={className}
    data-testid={`kg-catalog-section-${section.id}`}
  >
    <KgCatalogSectionHeader
      icon={icon}
      label={section.label}
      isOpen={isOpen}
      onToggle={onToggle}
      onExternalLink={onSectionExternalLink}
      itemCount={nodes.length}
    />
    <CollapsibleBody
      $isOpen={isOpen}
      aria-hidden={!isOpen}
      data-testid={`kg-catalog-section-body-${section.id}`}
    >
      <CollapsibleInner $isOpen={isOpen}>
        {nodes.length > 0 ? (
          <CardGrid>
            {nodes.map((node) => (
              <KgCatalogEntityTile
                key={node.id}
                node={node}
                expandedTableIds={expandedTableIds}
                onTableTileToggle={onTableTileToggle}
                onNodeClick={onNodeClick}
                isSelected={selectedNodeId === node.id}
              />
            ))}
          </CardGrid>
        ) : emptyMessage ? (
          <EmptyNote data-testid={`kg-catalog-section-empty-${section.id}`}>
            {emptyMessage}
          </EmptyNote>
        ) : null}
      </CollapsibleInner>
    </CollapsibleBody>
  </SectionCard>
);

export default KgCatalogSection;
